import Lottie from "react-lottie";
import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  background-color: transparent;
  width: 100px;
  left: min(32vw, 23vw);
`;